import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";

const token = localStorage.getItem("x-access-token");

/* ================= GET SETTINGS ================= */
export const getCompanySettings = createAsyncThunk(
  "settings/getCompanySettings",
  async () => {
    const response = await fetch(
      Configuration.BACK_BASEURL + "company-settings",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          /* "x-access-token": token, */
        },
      },
    );
    const data = await response.json();
    return data;
  },
);

/* ================= UPDATE SETTINGS ================= */
export const updateCompanySettings = createAsyncThunk(
  "settings/updateCompanySettings",
  async (formData) => {
    const response = await fetch(
      Configuration.BACK_BASEURL + "company-settings",
      {
        method: "PUT",
        headers: {
          /* "x-access-token": token, */
        },
        body: formData,
      },
    );
    const data = await response.json();
    return data;
  },
);

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    settings: null, // Add settings state
    loading: false,
    error: null, // Add error state
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanySettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanySettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(getCompanySettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateCompanySettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCompanySettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(updateCompanySettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default settingsSlice.reducer;
